import styled from 'styled-components';

import Icon from '../Icon';

import { colors } from '../../../theme';

export const StyledButton = styled.button`
    width: ${({ width }) => width};
    background: ${colors.blue};
    padding: ${({ isLoading }) => (isLoading ? '5px 20px 4px ' : '8px 20px')};
    color: white;
    text-transform: uppercase;
    font-weight: 500;
    line-height: 24px;
    text-decoration: none;
    word-break: keep-all;
    font-size: 0.875rem;
    border-radius: 3px;
    border: 0;
    outline: none;
    cursor: pointer;
    left: 0;

    :hover {
        background: #59adff;
    }

    :focus {
        background: #1f7fdc;
    }
`;

export const StyledIcon = styled(Icon)`
    color: white;

    animation-name: spin;
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`;
